import React from "react";
import { Button, Dialog, Box } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import useStyles from "./../useStyles";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const PopupModal = ({ title, children, open, setOpen, onConfirm, component, ...props }) => {
    const classes = useStyles();

    return (
        <Dialog
            PaperProps={{
                style: {
                    margin: 0,
                },
            }}
            style={{ width: "100vw", margin: 0 }}
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="confirm-dialog"
            TransitionComponent={Transition}
        >
            <DialogContent style={{ padding: "1vw" }}>{component}</DialogContent>
            <DialogActions style={{ alignContent: "center", alignSelf: "center" }}>
                <Box className={classes.row}>
                    <Button variant="outlined" onClick={() => setOpen(false)}>
                        Ok
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default PopupModal;
